<template>
  <div class="support-widget">
    <transition name="fade-up" mode="out-in">
      <b-btn v-if="!visible" class="px-3" variant="primary" pill @click="show">
        <i class="mr-1 icon-question" /> Support
      </b-btn>

      <div
        v-if="visible"
        class="widget-form bg-white shadow rounded overflow-hidden"
      >
        <div
          class="d-flex align-items-center justify-content-between bg-primary font-lg"
        >
          <div class="px-2 text-white">Contact Us</div>
          <b-btn
            class="text-white no-resize"
            variant="link"
            @click="visible = false"
          >
            <i class="icon-close" />
          </b-btn>
        </div>

        <b-form class="p-3" @submit.prevent="submit">
          <b-form-group
            class="required"
            label="FIRST NAME"
            invalid-feedback="First name is required"
          >
            <b-input
              v-model="form.first_name"
              :state="!$v.form.first_name.$error && null"
              autofocus
            />
          </b-form-group>

          <b-form-group
            class="required"
            label="LAST NAME"
            invalid-feedback="Last name is required"
          >
            <b-input
              v-model="form.last_name"
              :state="!$v.form.last_name.$error && null"
            />
          </b-form-group>

          <b-form-group
            class="required"
            label="EMAIL"
            invalid-feedback="Email is required"
          >
            <b-input
              v-model="form.email"
              :formatter="v => v.toLowerCase()"
              :state="!$v.form.email.$error && null"
            />
          </b-form-group>

          <b-form-group
            class="required"
            label="HOW CAN WE HELP YOU?"
            invalid-feedback="Message is required"
          >
            <b-textarea
              v-model="form.message"
              :state="!$v.form.message.$error && null"
              rows="3"
              max-rows="6"
            />
          </b-form-group>

          <b-btn
            :disabled="submitted"
            class="no-resize"
            type="submit"
            variant="primary"
            block
          >
            {{ submitted ? "Submitted" : "Submit" }}
          </b-btn>
        </b-form>
      </div>
    </transition>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import API from "@/api";

export default {
  mixins: [validationMixin],

  data: () => ({
    form: {
      first_name: "",
      last_name: "",
      email: "",
      message: ""
    },
    submitted: false,
    visible: false
  }),

  methods: {
    reset() {
      this.form.first_name = "";
      this.form.last_name = "";
      this.form.email = "";
      this.form.message = "";
      this.submitted = false;
    },

    show() {
      this.reset();
      this.$v.$reset();
      this.visible = true;
    },

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.submitted = true;
      await API.supportRequest(this.form);

      setTimeout(() => {
        this.visible = false;
      }, 1000);
    }
  },

  validations: {
    form: {
      first_name: { required },
      last_name: { required },
      email: { required, email },
      message: { required }
    }
  }
};
</script>

<style lang="scss">
.support-widget {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 1rem;
  z-index: 1030;

  .widget-form {
    width: 20rem;
    max-width: 100%;
  }
}
</style>
